import axios from 'axios';

export const getAll = async () => {
    const url = '/api/v1/user_profile/summary';
    const res = await axios.get(url);
    return res.data;
};